import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class InteractBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.interact = {
            update: (element: HTMLElement, valueAccessor: () => any) => {
                let interactable = ko.unwrap(valueAccessor());
                let overlay = $(element).find('.interact-overlay');

                if (interactable === false) {
                    if (overlay.length === 0) {
                        overlay = $('<div class="interact-overlay">').appendTo($(element));
                    }

                    $(element).css('position', 'relative');
                } else {
                    overlay.remove();
                }
            }
        };
    }
}